export default {
  columns: {
    status: 'status',
    applicantId: 'id',
    applicantName: 'firstName',
    analysisEndDate: 'analysisEndDate',
    buttonControls: 'buttonControls',
  },
};
